// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210405/js/" + chunkId + "." + {"44":"4be4bcae","225":"5aa06c17","481":"9993bab4","486":"99204eaf","770":"6b9b3781"}[chunkId] + ".0.6796772606849906.chunk.js";
};